import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Packaging } from 'src/app/core/models/packaging';
import { PackagingService } from 'src/app/core/services/general/packaging.service';

@Component({
  selector: 'app-packaging-input',
  templateUrl: './packaging-input.component.html',
  styleUrls: ['./packaging-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PackagingInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PackagingInputComponent,
    },
  ],
})
export class PackagingInputComponent {
  @Input()
  title = "Select Packaging...";

  @Input()
  isDisabled = false;

  @Input()
  filterCommodityUuid = null;

  public value?: string;
  public localValue?: CustomSelectOption;

  public packagingsList: Array<CustomSelectOption> = [];
  public packagings: Array<Packaging> = [];

  constructor(
    private packagingService: PackagingService,
  ) {
    this.packagingService
      .all()
      .subscribe((res: Array<Packaging>) => {
        this.packagings = res.map((el) => {
          return new Packaging(el);
        });

        this.packagingsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  getFilteredList() {
    let list =  this.packagings.filter((el) => {
      if (this.filterCommodityUuid) {
        return el.commodity_packagings?.find((cp) => cp.commodity_uuid == this.filterCommodityUuid);
      }
      return true;
    });

    return this.packagingsList.filter((el) => list.find((p) => p.uuid == el.value));
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.packagingsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
